import * as React from 'react';
import AppContent from '../components/AppContent';
import Header from '../components/Header';
import './App.css';

class App extends React.Component {
  public render() {
    return (
      <div className="App">
        <Header pageTitle="Deployment Engine Sample React SPA" />
        <div className="container-fluid">
          <div className="row">
            <div className="col">
              <AppContent />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
